<form [formGroup]="searchForm">
  <mat-form-field class="search-bar">
    <button
      mat-flat-button
      matPrefix
      disableRipple
      (click)="handleEvent($event)"
      [matMenuTriggerFor]="criteriaMenu"
      class="search-bar__prefix only-icon"
      [tabIndex]="isSideBarOpen ? 0 : -1"
      [attr.aria-label]="'sidebar.title' | translate">
      <span class="odilo-icon" aria-hidden="true">{{ selectedCriteria?.icon }}</span>
      <span class="odilo-icon" aria-hidden="true">expand_more</span>
    </button>
    <input
      #queryField="matInput"
      type="text"
      maxlength="500"
      aria-labelledby="searchButton"
      matInput
      [formControlName]="'query'"
      (click)="$event.stopPropagation()"
      (keydown.enter)="onEnter($event)"
      (keydown.arrowdown)="onArrows()"
      (keydown.arrowup)="onArrows()"
      [matAutocomplete]="auto"
      [matAutocompleteDisabled]="disableSuggestions"
      [tabIndex]="isSideBarOpen ? 0 : -1" />

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="goTo($event)">
      <mat-option *ngFor="let suggestion of suggestions | async" [value]="suggestion">
        <span class="odilo-icon">{{ getFilterIcon(suggestion.filter) }}</span>
        <span style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block; margin-inline-start: 8px;">{{ suggestion.label }}</span>
      </mat-option>
    </mat-autocomplete>
    <button
      id="searchButton"
      matSuffix
      mat-icon-button
      [attr.aria-label]="'tooltip.search' | translate"
      (click)="submit()">
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>

  <mat-menu #criteriaMenu class="criteria-menu">
    <ng-container *ngFor="let criteria of searchModel.getSearchCriterias()">
      <button mat-menu-item (click)="onSelectCriteria(criteria)" [class.selected]="criteria === selectedCriteria">
        <span class="odilo-icon" aria-hidden="true">{{ criteria.icon }}</span>
        {{ criteria.key | translate }}
        <span class="selected-icon odilo-icon" [attr.aria-label]="'sidebar.filters.selected' | translate">check</span>
      </button>
    </ng-container>
  </mat-menu>
</form>
